"use client";

import { useState } from "react";
import Link from "next/link";
import { useAuthStore } from "@/store/auth";
import { TierInfoModal } from "@/components/ui/TierInfoModal";

export function DashboardHeader() {
  const { isLoggedIn } = useAuthStore();
  const [tierModalOpen, setTierModalOpen] = useState(false);

  return (
    <>
      <header className="bg-bg/90 backdrop-blur-md border-b border-border px-4 py-3">
        <div className="flex items-center justify-between gap-2">
          {/* 로고 + 태그라인 (사용자 결정 2026-05-10 — 흐름 함축: 트렌드 → 매장 → 상권) */}
          <div className="min-w-0 flex-1">
            <div className="flex items-baseline gap-2 flex-wrap">
              <h1 className="text-lg font-black text-text tracking-tight">
                🔥 <span className="text-primary">TrendRain</span>
              </h1>
            </div>
          </div>

          {/* 우측 영역 */}
          <div className="flex items-center gap-2 shrink-0">
            {/* 왜 만들었나 pill — 2026-05-25 manifesto */}
            <Link
              href="/why"
              className="text-2xs font-semibold text-text-sub hover:text-primary border border-border hover:border-primary/40 rounded-full px-2.5 py-1 transition-colors"
            >
              왜?
            </Link>
            {/* 기능 안내 pill — 2026-05-15 베타 정책 (가격 표기 숨김) */}
            <button
              onClick={() => setTierModalOpen(true)}
              className="flex items-center gap-1 text-2xs font-semibold text-text-sub hover:text-primary border border-border hover:border-primary/40 rounded-full px-2.5 py-1 transition-colors"
              aria-label="기능 안내"
            >
              <span className="text-2xs">ⓘ</span>
              <span>기능 안내</span>
            </button>

            {isLoggedIn ? (
              <>
                <Link
                  href="/mypage/notifications"
                  aria-label="알림 설정"
                  className="text-text-sub hover:text-text transition-colors text-xl"
                >
                  🔔
                </Link>
                <Link href="/mypage" aria-label="마이페이지">
                  <span className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary font-bold text-sm">
                    MY
                  </span>
                </Link>
              </>
            ) : (
              <Link
                href="/login"
                className="text-xs font-semibold text-primary border border-primary/40 px-3 py-1.5 rounded-full hover:bg-primary-muted transition-colors"
              >
                로그인
              </Link>
            )}
          </div>
        </div>
      </header>

      {/* 모달은 header 형제로 — header 의 backdrop-blur 가 만드는 stacking context 밖에서 렌더돼야
          fixed inset-0 가 뷰포트 기준으로 작동 (잘림·클릭 먹통 방지) */}
      <TierInfoModal open={tierModalOpen} onClose={() => setTierModalOpen(false)} />
    </>
  );
}
